var _path, _rect, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoodFit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 25.3333L12.2857 26.6667C13.1367 27.6395 14.4838 27.9957 15.7386 28H20.2042C21.7059 28.0021 23.108 27.2104 23.9399 25.8936L28.3792 18.8761C29.1356 17.6804 29.2058 16.143 28.5622 14.8755C27.9186 13.6091 26.6656 12.8176 25.3012 12.8176H20.9311L21.9184 8.13134V8.13026C22.1665 6.94959 21.7364 5.72394 20.8183 4.9975L20.1381 4.45967C19.6419 4.06541 19.0084 3.9154 18.4004 4.04612C17.7914 4.1779 17.2657 4.57753 16.9556 5.14536C15.9185 7.1342 14.4141 9.82706 13.2313 11.344C12.6704 12.0633 11.8536 12.4961 11 12.8176",
    stroke: "currentColor",
    strokeWidth: 1.5
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 11,
    width: 8,
    height: 16,
    rx: 1,
    stroke: "currentColor",
    strokeWidth: 1.5
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 7,
    cy: 23,
    r: 1,
    stroke: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoodFit);
export default __webpack_public_path__ + "static/media/good-fit.679a7a9fd8f4c8f9deb377e97e1b1500.svg";
export { ForwardRef as ReactComponent };